import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_ATTENDANCE,
  DELETE_ATTENDANCE,
  UPDATE_ATTENDANCE,
  ADD_NEW_ATTENDANCE,
} from "./actionType";

import {
  getAttendanceSuccess,
  getAttendanceFail,
  deleteAttendanceSuccess,
  deleteAttendanceFail,
  updateAttendanceSuccess,
  updateAttendanceFail,
  addAttendanceSuccess,
  addAttendanceFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveAttendanceApi,
  getAttendanceApi,
  updateAttendanceApi,
  deleteAttendanceApi,
  addNewAttendanceApi
} from "../../helpers/backend_helper";

function* getAttendance({ payload: attendance }) {
  try {
    const response = yield call(getAttendanceApi, attendance);
    yield put(getAttendanceSuccess(GET_ATTENDANCE, response.data));
  } catch (error) {
    yield put(getAttendanceFail(GET_ATTENDANCE, error));
  }
}

function* onUpdateAttendance({ payload: attendance }) {
  try {
    if (attendance.setApprove) {
      const response = yield call(approveAttendanceApi, attendance);
      yield put(updateAttendanceSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateAttendanceApi, attendance);
      yield put(updateAttendanceSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateAttendanceFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteAttendance({ payload: attendance }) {
  try {
    const response = yield call(deleteAttendanceApi, attendance);
    yield put(deleteAttendanceSuccess({ attendance, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteAttendanceFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewAttendance({ payload: attendance }) {
  try {
    const response = yield call(addNewAttendanceApi, attendance);
    yield put(addAttendanceSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addAttendanceFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetAttendance() {
  yield takeEvery(GET_ATTENDANCE, getAttendance);
}

export function* watchUpdateAttendance() {
  yield takeEvery(UPDATE_ATTENDANCE, onUpdateAttendance);
}

export function* watchDeleteAttendance() {
  yield takeEvery(DELETE_ATTENDANCE, onDeleteAttendance);
}

export function* watchAddNewAttendance() {
  yield takeEvery(ADD_NEW_ATTENDANCE, onAddNewAttendance);
}

function* attendanceSaga() {
  yield all([
    fork(watchGetAttendance),
    fork(watchDeleteAttendance),
    fork(watchUpdateAttendance),
    fork(watchAddNewAttendance)
  ]);
}

export default attendanceSaga;
